import React from 'react';
import { FullSizeColumn } from '../../../../Components/FlexBox';
import SectionCountersRow from './SectionCountersRow';

const SectionCountersWidget = function SectionCountersWidget({
  sectionCounters,
}) {
  return (
    <FullSizeColumn gap="24px">
      <SectionCountersRow
        title="TOTAL"
        target={sectionCounters?.target}
        totalCount={sectionCounters?.totalCount}
        answeredCount={sectionCounters?.answeredTotalCount}
        unansweredCount={sectionCounters?.unansweredTotalCount}
        outcomeCounters={sectionCounters?.outcomeCounters}
      />
      {sectionCounters?.sectionCounters?.map(
        ({
          name,
          callCount,
          unansweredCallCount,
          answeredCallCount,
          outcomeCounters,
        }) => (
          <SectionCountersRow
            key={name}
            title={name}
            totalCount={callCount}
            answeredCount={answeredCallCount}
            unansweredCount={unansweredCallCount}
            outcomeCounters={outcomeCounters}
          />
        )
      )}
    </FullSizeColumn>
  );
};

export default SectionCountersWidget;
